"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolbarSearchFilter = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const public_1 = require("../../common/public");
const controls_1 = require("../../controls");
const types_1 = require("../collectionModel/types");
const DEFAULT_SEARCH_DEBOUNCE_TIME = 250;
function toolbarSearchFilter({ property, operation = core_1.FILTER_OPERATION.contains, collation = core_1.FILTER_COLLATION.ignorecase, decorators, disabled, groupId = '', fieldConfig }) {
    const { placeholder, maxLength, mode = controls_1.SEARCH_MODE.automatic, searchDebounceTimeInMs = DEFAULT_SEARCH_DEBOUNCE_TIME, onChange, size } = fieldConfig || {};
    return {
        decorators,
        disabled,
        hasStretch: size === public_1.CONTROL_SIZE.full,
        render: (model, { disabled }) => {
            return (react_1.default.createElement(core_1.ModelRenderer, { model: model, render: ({ value }) => {
                    return (react_1.default.createElement(controls_1.Search, { value: String(value.filters.getFilterValue({ property, groupId }) || ''), size: size, mode: mode, placeholder: placeholder, maxLength: maxLength, searchDebounceTimeInMs: searchDebounceTimeInMs, onChange: onChange, disabled: disabled, onSearch: (value) => {
                            model.setFilter({ property, groupId }, value
                                ? {
                                    operation,
                                    collation,
                                    value: value,
                                    type: types_1.COLLECTION_MODEL_FILTER_TYPES.search
                                }
                                : null);
                        }, onClear: () => {
                            model.setFilter({ property, groupId }, null);
                        } }));
                } }));
        }
    };
}
exports.toolbarSearchFilter = toolbarSearchFilter;
//# sourceMappingURL=toolbarSearchFilter.js.map